









































































import Vue from 'vue';
import { LakDruh } from '@/modules/ciselnik/dilenske/lakDruh';
import { genVuexComputeds } from '@/main/pages/editFactory';

import OZakazkaSmluvniPartnerTypSelect from './components/microcomponents/SmluvniPartnerTypSelect.vue';
import OZakazkaSkupinaProfilSelect from './components/microcomponents/SkupinaProfilSelect.vue';
import OZakazkaProvozovnaSelect from './components/microcomponents/ProvozovnaSelect.vue';
import { store } from './store/edit';
import { editMutations } from './store/types';

export default Vue.extend({
	name: 'ZakladniInformace',
	components: {
		OZakazkaSmluvniPartnerTypSelect,
		OZakazkaSkupinaProfilSelect,
		OZakazkaProvozovnaSelect,
		LakDruhSelect: LakDruh.components.Select,
	},
	props: {
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			FeedbackMarks: {
				0: this.Localize('POOR'),
				1: '',
				2: '',
				3: '',
				4: '',
				5: this.Localize('AVERAGE_FB'),
				6: '',
				7: '',
				8: '',
				9: '',
				10: this.Localize('EXCELLENT'),
			},
		};
	},
	computed: {
		mutationsMappers(): object {
			return {
				lakDruh: `${this.storeUri}/${editMutations.OZAKAZKA_LAK_DRUH_SELECT_MAPPER}`,
			};
		},
		...genVuexComputeds(store),
		lakdruhFilter(): object {
			return {
				VyrobekvozOzn: this.ZakazkaDruh,
				VyrazenPrp: false,
			};
		},
	},
});
